module.exports = __webpack_public_path__ + "static/media/chip_delele.a04e8d28.svg";